import { useState, useEffect, useRef } from 'react';

/**
 * Returns whether the container element is in landscape orientation,
 * i.e. its rendered width exceeds the given breakpoint (default 480px).
 *
 * Uses ResizeObserver so it updates without a full re-render cycle.
 *
 * @param {number} [breakpoint=480]
 * @returns {{ ref: React.RefObject, isLandscape: boolean }}
 */
export function useContainerOrientation( breakpoint = 480 ) {
	const ref = useRef( null );
	const [ isLandscape, setIsLandscape ] = useState( false );

	useEffect( () => {
		const el = ref.current;
		if ( ! el ) return;

		const observer = new ResizeObserver( ( [ entry ] ) => {
			const width = entry.contentRect.width;
			setIsLandscape( width >= breakpoint );
		} );

		observer.observe( el );
		return () => observer.disconnect();
	}, [ breakpoint ] );

	return { ref, isLandscape };
}
